/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MasterScheduleCalendarResponse } from '../../models/master-schedule-calendar-response';

export interface GetMasterScheduleCalendar$Params {
  dateFrom?: string;
  dateTo?: string;
}

export function getMasterScheduleCalendar(http: HttpClient, rootUrl: string, params?: GetMasterScheduleCalendar$Params, context?: HttpContext): Observable<StrictHttpResponse<MasterScheduleCalendarResponse>> {
  const rb = new RequestBuilder(rootUrl, getMasterScheduleCalendar.PATH, 'get');
  if (params) {
    rb.query('dateFrom', params.dateFrom, {});
    rb.query('dateTo', params.dateTo, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MasterScheduleCalendarResponse>;
    })
  );
}

getMasterScheduleCalendar.PATH = '/api/scheduler/master-schedule/calendar';
